const contentResponseUI = {
    default: {
      fields: ["name_flow", "syntax_start", "message_success", "message_waiting", "message_fail", "syntax_end"],
    },
  };
  
  export default contentResponseUI;